<template>
  <transition enter-active-class="transform transition-all ease-in-out duration-300"
    enter-from-class="-translate-x-full" enter-to-class="translate-x-0"
    leave-active-class="transform transition ease-in-out duration-300" leave-from-class="translate-x-0"
    leave-to-class="-translate-x-full" appear>
    <div class="transition-all flex flex-col border-r border-gray-200 pt-5 bg-gray-100 shadow-lg h-full"
      :class="state.activeTab == 'feedback' ? 'w-96' : 'w-72'" v-if="Identity.IsAuthenticated">
      <div class="flex flex-col">
        <div class="flex items-center px-6">
          <img class="w-auto h-24 mx-auto" :src="logo!" alt="Workflow" />
        </div>

        <!-- User account dropdown -->
        <Menu as="div" class="mt-3 px-3 relative inline-block text-left">
          <div>
            <MenuButton
              class="group w-full bg-gray-100 mt-2 px-3.5 py-2 text-sm text-left font-medium text-gray-700 hover:bg-gray-200 border-2">
              <span class="flex w-full justify-between items-center">
                <span class="flex min-w-0 items-center justify-between space-x-3">
                  <span class="inline-block h-8 w-8 rounded-full overflow-hidden bg-gray-100">
                    <svg class="h-full w-full text-oekoprofitgruen" fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  </span>
                  <span class="flex-1 flex flex-col min-w-0 text-sm">
                    <span class="text-gray-900 font-medium truncate">
                      {{ Identity.DisplayName }}
                    </span>
                    <span class="text-gray-500 truncate">
                      {{ Identity.Claims?.role }}
                    </span>
                  </span>
                </span>
                <SelectorIcon class="flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
              </span>
            </MenuButton>
          </div>
          <transition enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95">
            <MenuItems
              class="z-10 mx-3 origin-top absolute right-0 left-0 mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none">
              <div class="py-1">

                <MenuItem v-slot="{ active }">
                <RouterLink to="/Standorte" :class="[
                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                  'block px-4 py-2 text-sm',
                ]">
                  Meine Standorte anzeigen
                </RouterLink>
                </MenuItem>
              </div>

              <div v-if="(Identity.IsAdmin) && Identity.HasSelectedStandort" class="py-1">
                <MenuItem v-slot="{ active }">
                <div @click="switchToAdminMode" :class="[
                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                  'block px-4 py-2 text-sm',
                ]">
                  Zur Administration wechseln
                </div>
                </MenuItem>
              </div>

              <div class="py-1">
                <MenuItem v-slot="{ active }">
                <div @click="logout" :class="[
                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                  'block px-4 py-2 text-sm',
                ]">
                  Abmelden
                </div>
                </MenuItem>
              </div>
            </MenuItems>
          </transition>
        </Menu>
        <router-link v-if="Identity.HasSelectedStandort" to="/Standorte"
          class="mt-3 mx-3 p-2 bg-violet-200 text-center text-sm flex flex-col rounded-md border border-violet-400">
          <span class="text-xs font-bold">Standort</span>
          {{ Standort.Grunddaten?.value?.name }}
        </router-link>
        <div v-if="!Identity.HasSelectedStandort && Identity.IsAdmin"
          class="mt-3 mx-3 p-2 bg-red-200 text-center text-sm flex flex-col rounded-md border border-red-400">
          Administration
        </div>
        <div class="grow relative z-0 inline-flex shadow-sm rounded-md mx-auto mt-3"
          v-if="Identity.HasSelectedStandort">
          <button type="button" @click="switchTab('navigation')" :class="[
            state.activeTab == 'navigation'
              ? 'focus:ring-oekoprofitgruen focus:border-oekoprofitgruen bg-oekoprofitgruen text-white'
              : 'text-gray-700 bg-white',
          ]"
            class="relative inline-flex items-center px-4 py-1 rounded-l-md border border-gray-300 text-xs font-medium focus:z-10 focus:outline-none focus:ring-1">
            Navigation
          </button>
          <button type="button" @click="switchTab('feedback')" :class="[
            state.activeTab == 'feedback'
              ? 'focus:ring-oekoprofitgruen focus:border-oekoprofitgruen bg-oekoprofitgruen text-white'
              : 'text-gray-700 bg-white',
          ]"
            class="-ml-1 relative inline-flex items-center px-4 py-1 rounded-r-md border border-gray-300 text-xs font-medium focus:z-10 focus:outline-none focus:ring-1">
            Anmerkungen
          </button>
          <span
            class="hidden absolute top-0.5 right-0.5 h-3 w-3 transform -translate-y-1/2 translate-x-1/2 rounded-full ring-2 ring-white" />
        </div>
      </div>

      <div class="grow flex flex-col border-gray-300 border-t mt-3 overflow-y-auto overflow-x-hidden">
        <!-- Navigation -->
        <div class="px-3 mt-2 pb-20" v-if="state.activeTab == 'navigation'">
          
          <!-- Sidebar Search -->
          <div class="pb-2">
            <div class="relative rounded-md shadow-sm">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" aria-hidden="true">
                <SearchIcon class="mr-3 h-4 w-4 text-gray-400" />
              </div>
              <input type="text" name="search" id="search" v-model="state.navigationFilter"
                class="focus:border-oekoprofitgruen block w-full pl-10 py-2 sm:text-sm border-gray-300 rounded-md"
                placeholder="Navigation filtern" />
              <div v-if="state.navigationFilter" class="absolute inset-y-0 right-0 pr-3 flex items-center z-50">
                <XCircleIcon class="h-5 w-5 text-gray-400 cursor-pointer" @click="state.navigationFilter = ''" />
              </div>
            </div>
          </div>

          <Vorarlberg>
            <div class="pb-2">
            <div class="relative rounded-md bg-gray-200 p-1 border border-gray-300 shadow-inner flex flex-row">
             <ToggleSwitch id="nurPflichtBereiche" colspan="6" name="nurPflichtBereiche" label="Nur Pflichtbereiche anzeigen" v-model="state.nurPflichtBereiche" />
                  
            </div>
          </div>
          </Vorarlberg>

          <!-- Admin navigation -->
          <div class="space-y-1" v-if="(Identity.IsAdmin || Identity.IsBerater) && !Identity.HasSelectedStandort">
            <div v-for="(section, i) in state.adminNavigation">
              <div v-if="section.title" class="border border-gray-300 bg-gray-200 text-center py-0.5 rounded-md mb-2 text-xs font-bold">{{
                section.title }}</div>
              <router-link v-for="item in section.items!.filter(
                (navitem: NavigationItem) =>
                  navitem.title!
                    .toLowerCase()
                    .indexOf(state.navigationFilter.toLowerCase()) > -1,
              )" :key="item.title" :to="item.route!" :class="[item.title == routeName
                ? 'bg-gray-200 text-gray-900'
                : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50',
                'group flex items-center px-2 py-2 text-sm font-medium rounded-md']"
                :aria-current="item.title == routeName ? 'page' : undefined" @click="state.activeEntity = item.title!">
                <component :is="Icons[item.icon]"
                  class="text-gray-400 mr-3 flex-shrink-0 h-6 w-6 transition-colors duration-300" aria-hidden="true" />
                <div class="flex flex-col">
                  <span class="text-sm truncate">{{ item.title }}</span>
                  <span class="text-xs">{{ item.subtitle }}</span>
                </div>
              </router-link>
            </div>
          </div>

          <!-- Teilnehmer navigation -->
          <div class="space-y-1 flex flex-col gap-3" v-if="Identity.HasSelectedStandort">
            <div
              v-for="section in state.teilnehmerNavigation?.sections.filter((s: NavigationSection) => s.items.some((navitem: NavigationItem) => showNavItem(navitem)))">
              <div v-if="section.title" class="border border-gray-300 bg-gray-200 text-center py-1 rounded-md mb-2">{{
                section.title }}</div>
              <router-link v-for="item in section.items.filter((navitem: NavigationItem) => showNavItem(navitem))"
                :key="item.title"
                :to="item.route!"
                :class="[item.route == useRoute().path
                  ? 'bg-gray-200 text-gray-900 border border-gray-300'
                  : 'text-gray-700 hover:text-gray-900 border border-gray-100 hover:bg-gray-50',
                  'group flex items-center px-2 py-2 text-sm font-medium rounded-md']"
                :aria-current="item.title == routeName ? 'page' : undefined" @click="state.activeEntity = item.title">
                <component :is="Icons[item.icon]"
                  class="text-gray-400 mr-3 flex-shrink-0 h-6 w-6 transition-colors duration-300" aria-hidden="true" />
                <div class="flex flex-col">
                  <div class="text-sm truncate flex flex-row gap-1">
                    <div class="h-full">{{ item.title }}</div> 
                    <div v-if="item.istPflichtbereich" class="leading-4 text-red-400 text-2xl ">*</div>
                  </div>
                  <span class="text-xs">{{ item.subtitle }}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Feedback -->
        <div class="px-3 mt-2 pt-2 pb-20" v-if="state.activeTab == 'feedback'">
          <div class="space-y-1">
            <div v-for="item in Feedback.Items.value" :key="item.id" :class="[
              item.route != routePath
                ? 'bg-gray-200 text-gray-900'
                : 'text-gray-700 hover:text-gray-900 hover:bg-yellow-100',
              'group px-2 py-2 rounded-md bg-yellow-100 border flex-col flex relative pr-8',
            ]">
              <span class="text-sm font-bold">
                {{ item.titel }}
              </span>
              <span class="text-sm">
                {{ item.text }}
              </span>
              <span class="text-xs text-gray-500 mt-4">
                {{ item.autor }} - {{ item.zeitstempel }}
              </span>
              <span class="absolute right-2 bottom-1">
                <span class="inline-flex items-center gap-1">
                  <XCircleIcon @click="Feedback.DeleteFeedback(item);" class="h-6 w-6"></XCircleIcon>
                  <CheckCircleIcon @click="item.istErledigt = !item.istErledigt; Feedback.Erledige(item);"
                    class="h-6 w-6"
                    :class="item.istErledigt ? 'text-green-500' : 'text-yellow-300 hover:text-green-500 cursor-pointer'">
                  </CheckCircleIcon>
                  <RouterLink :to="item.route">
                    <ArrowCircleRightIcon class="h-6 w-6 text-green-500"></ArrowCircleRightIcon>
                  </RouterLink>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from "vue-router/auto";
import { inject, computed, reactive, watch, onMounted, watchEffect, ref } from "vue";
import { ServiceSymbol, type IService } from "../service";
import { useFeedback } from "../composables/Feedback";

import { useServices } from "/src/services";

import { ArrowCircleRightIcon, SearchIcon, SelectorIcon, XCircleIcon } from "@heroicons/vue/solid";

import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";

import {
  CheckCircleIcon
} from "@heroicons/vue/outline";

import * as Icons from "@heroicons/vue/outline";

import { useIdentity } from "../features/identity";
import type { SwitchStandortResponse } from "../services/concierge/commands";
import type { Navigation, NavigationItem, NavigationSection } from "../services/configuration/model";
import router from "../router";
import ToggleSwitch from "/src/components/parts/inputs/ToggleSwitch.vue";
import type VorarlbergVue from "./utility/TenantTemplates/Vorarlberg.vue";

const { Concierge, Standort, Configuration, Datenjahr, Storage } = useServices();

const service = inject(ServiceSymbol) as IService;

const { Feedback } = useFeedback();

const { Identity } = useIdentity();

const logo = ref(null);

watchEffect(() => {
  if (!Identity.IsAuthenticated)
    return '';

  Storage.GetAsset('logo.png')
    .then((asset) => logo.value = URL.createObjectURL(asset));
})



Standort.LoadGrunddaten();

const routeName = computed(() => {
  return useRoute()?.name;
});

const routePath = computed(() => {
  return useRoute()?.path;
});


interface IFormState {
  activeTab: string;
  activeEntity: string;
  adminNavigation: NavigationSection[],
  teilnehmerNavigation?: Navigation,

  navigationFilter: string;
  feedbacktext: string;

  nurPflichtBereiche?: boolean;
}

const state = reactive<IFormState>({
  feedbacktext: '',
  activeTab: 'navigation',
  activeEntity: '',
  navigationFilter: '',
  adminNavigation: [
    {
      title: "Benutzer/Teilnehmer",
      items: [
        { title: "Benutzer", route: "/admin/benutzer", icon: 'UserIcon', isVisible: true },
        { title: "Teilnehmer", route: "/admin/teilnehmer", icon: 'OfficeBuildingIcon', isVisible: true },
      ]
    },
    {
      title: "Programm",
      items: [

        { title: "Programme", route: "/admin/configuration/programme", icon: 'DocumentReportIcon', isVisible: true },
        { title: "Navigation für Teilnehmeransicht", route: "/admin/navigation", icon: 'MenuAlt2Icon', isVisible: true },
      ]
    },
    {
      title: "Auswertungen",
      items: [
        { title: "Energiedaten", route: "/admin/auswertungen", icon: 'DocumentReportIcon', isVisible: true },
        { title: "Massnahmen (Broschüre)", route: "/admin/MassnahmenBroschuere", icon: 'DocumentReportIcon', isVisible: true },
        { title: "Massnahmen (alle)", route: "/admin/MassnahmenAlle", icon: 'DocumentReportIcon', isVisible: true },
        { title: "Klimabilanzen", route: "/admin/KlimabilanzenAlle", icon: 'DocumentReportIcon', isVisible: true },
        { title: "Dekarbonisierungsstrategien", route: "/admin/DekarbonisierungsstrategienAlle", icon: 'DocumentReportIcon', isVisible: true },
        { title: "Energieträger", route: "/admin/EnergietraegerAlle", icon: 'DocumentReportIcon', isVisible: true },
      ]
    },
    {
      title: "Konfiguration",
      items: [

        { title: "Einheiten", route: "/admin/configuration/einheiten", icon: 'BeakerIcon', isVisible: true },
        { title: "Heizgradtage / Kältegradtage", route: "/admin/configuration/heizgradtage", icon: 'SunIcon', isVisible: true },
        { title: "CO2-Preise", route: "/admin/configuration/co2preise", icon: 'CurrencyEuroIcon', isVisible: true },
        { title: "Funktionen/Rollen", route: "/admin/configuration/funktion", icon: 'UsersIcon', isVisible: true },
        { title: "Abfallarten", route: "/admin/configuration/abfallarten", icon: 'TrashIcon', isVisible: true, editableForBerater: true },
        { title: "Entsorger", route: "/admin/configuration/entsorger", icon: 'TrashIcon', isVisible: true, editableForBerater: true },
        { title: "Branchen", route: "/admin/configuration/branchen", icon: 'ViewListIcon', isVisible: true },
        { title: "Freigabestatus", route: "/admin/configuration/freigabestatus", icon: 'ViewListIcon', isVisible: true },
        { title: "Audit-Checkliste", route: "/admin/configuration/auditcheckliste", icon: 'ClipboardListIcon', isVisible: true },
        { title: "Betriebsgroessen", route: "/admin/configuration/betriebsgroessen", icon: 'ViewListIcon', isVisible: true },
        { title: "Betriebsarten", route: "/admin/configuration/betriebsarten", icon: 'ViewListIcon', isVisible: true },
        { title: "Gebäudezweck", route: "/admin/configuration/gebaeudezweck", icon: 'ViewListIcon', isVisible: true },
        { title: "Anlagenteilzweck", route: "/admin/configuration/anlagenteilzweck", icon: 'ViewListIcon', isVisible: true },
        { title: "Umweltauswirkungen", route: "/admin/configuration/umweltauswirkungen", icon: 'ViewListIcon', isVisible: true, editableForBerater: true },
        { title: "Rechtsbasis (Bescheide)", route: "/admin/configuration/rechtsbasis", icon: 'ViewListIcon', isVisible: true },
        { title: "Auflagentypen", route: "/admin/configuration/auflagentyp", icon: 'ViewListIcon', isVisible: true },
        { title: "Auflagenvorlagen", route: "/admin/configuration/Auflagenvorlagen", icon: 'ViewListIcon', isVisible: true, editableForBerater: true },
        { title: "Anhangskategorien", route: "/admin/configuration/anhangskategorie", icon: 'ViewListIcon', isVisible: true },
        { title: "Einsatzstoffe", route: "/admin/configuration/einsatzstoffe", icon: 'ViewListIcon', isVisible: true },
        { title: "Produktionsrückstände", route: "/admin/configuration/produktionsrueckstaende", icon: 'ViewListIcon', isVisible: true },
        { title: "Energieträger", route: "/admin/configuration/energietraeger", icon: 'ViewListIcon', isVisible: true },
        { title: "Erhebungsmethoden", route: "/admin/configuration/erhebungsmethoden", icon: 'ViewListIcon', isVisible: true },
        { title: "Energiekategorien", route: "/admin/configuration/energiekategorie", icon: 'ViewListIcon', isVisible: true },
        { title: "Reinigungsmittelvorkehrung", route: "/admin/configuration/reinigungsmittelvorkehrung", icon: 'ViewListIcon', isVisible: true },
        { title: "Klimabilanz: Emissions-Scopes", route: "/admin/configuration/emissionsscopes", icon: 'ViewListIcon', isVisible: true },
        { title: "Klimabilanz: Emissions-Kategorien", route: "/admin/configuration/emissionskategorien", icon: 'ViewListIcon', isVisible: true },
        { title: "Mobilitätstypen", route: "/admin/configuration/mobilitaetstyp", icon: 'ViewListIcon', isVisible: true },
        { title: "Maßnahmen: Hauptkategorien", route: "/admin/configuration/hauptkategorie", icon: 'ViewListIcon', isVisible: true },
        { title: "Maßnahmenkategorien", route: "/admin/configuration/massnahmenkategorie", icon: 'ViewListIcon', isVisible: true },
        { title: "Wirtschaftliche Auswirkungen", route: "/admin/configuration/wirtschaftlicheAuswirkungen", icon: 'ViewListIcon', isVisible: true },
        { title: "Umsetzungsstatus", route: "/admin/configuration/umsetzungsstatus", icon: 'ViewListIcon', isVisible: true },
        { title: "Umweltaspekte", route: "/admin/configuration/umweltaspekte", icon: 'ViewListIcon', isVisible: true },
        { title: "Umweltwirkungskategorien", route: "/admin/configuration/umweltwirkungskategorie", icon: 'ViewListIcon', isVisible: true },
        { title: "Zertifizierungsoptionen", route: "/admin/configuration/zertifizierungsoption", icon: 'ViewListIcon', isVisible: true },
        { title: "Fragebogen", route: "/admin/configuration/FragebogenNachhaltigkeit", icon: 'ViewListIcon', isVisible: true },
        { title: "Maßnahmenempfehlungskategorien", route: "/admin/configuration/massnahmenempfehlungskategorie", icon: 'ViewListIcon', isVisible: true },
        { title: "Handlungsfelder", route: "/admin/configuration/standardhandlungsfeldeintraege", icon: 'ViewListIcon', isVisible: true },
      ]
    },
  ]
});

Configuration.GetNavigation(false).then((data) => state.teilnehmerNavigation = data as Navigation);

const { push } = useRouter();

const logout = (): void => {
  Identity.Discard();
  Datenjahr.ClearDatenjahr();
  Datenjahr.ClearTeilnahme();
  push("/Login");
};

const openProfile = (): void => {
  push({ path: "/me" });
};

const switchToAdminMode = async (): Promise<void> => {
  var response = await Concierge.SwitchStandort({ standortId: '' }) as SwitchStandortResponse;

  Identity.SetIdentity(Identity.DisplayName, response.token);
  Datenjahr.ClearDatenjahr();
  Datenjahr.ClearTeilnahme();

  Configuration.Token = response.token;
  Standort.Token = response.token;

  router.push({ path: "/Standorte" });
}

const showNavItem = (navitem: NavigationItem): boolean => {
  return navitem.isVisible
    && navitem.title.toLowerCase().indexOf(state.navigationFilter.toLowerCase()) > -1
    && (!navitem.awk || Datenjahr.Teilnahme?.value?.awk)
    && (!navitem.vs || Standort.Grunddaten?.value?.mitVsBericht)
    && ((navitem.istPflichtbereich && state.nurPflichtBereiche) || !state.nurPflichtBereiche)
    && !Datenjahr.Teilnahme.value?.programm?.ausgeblendeteNavigationseintraege?.some((n: NavigationItem) => n.id === navitem.id);
}

const loadCardDetailState = async (): Promise<void> => {
  /*if (service.isLatestTeilnahme) {
    state.navigation.forEach((nav: any) => nav.bgColorClass = "");
    state.teilnahmedaten.forEach((tdaten: any) => tdaten.bgColorClass = "");
    let cardDetails = (await service.get<any>(`/card/${service.identity.value.lastTeilnahmeId}`, true))?.cardDetails;

    state.navigation.forEach((nav: any) => {
      let cardDetail = cardDetails.find((detail: any) => detail.name === nav.cardName);

      switch (cardDetail?.state) {
        case "Open":
          nav.bgColorClass = "text-red-400";
          break;

        case "InProgress":
          nav.bgColorClass = "text-yellow-500";
          break;

        case "Finished":
          nav.bgColorClass = "text-oekoprofitgruen";
          break;

        default:
          nav.bgColorClass = "text-gray-500";
          break;
      }
    });

    state.teilnahmedaten.forEach((tdaten: any) => {
      let cardDetail = cardDetails.find((detail: any) => detail.name === tdaten.cardName);

      switch (cardDetail?.state) {
        case "Open":
          tdaten.bgColorClass = "bg-red-400";
          break;

        case "InProgress":
          tdaten.bgColorClass = "bg-yellow-500";
          break;

        case "Finished":
          tdaten.bgColorClass = "bg-oekoprofitgruen";
          break;

        default:
          tdaten.bgColorClass = "bg-gray-400";
          break;
      }
    });
  }
  else {
    state.navigation.forEach((nav: any) => nav.bgColorClass = "text-gray-400")
    state.teilnahmedaten.forEach((tdaten: any) => tdaten.bgColorClass = "bg-gray-300");
  }*/
}

const approve = async (): Promise<void> => {
  await service.approveTeilnahme(service.selectedTeilnahmeId);
};

const switchTab = (tab: string): void => {
  state.activeTab = tab;
  Feedback.FeedbackModus.value = tab == 'feedback';
}

watch(() => state.activeEntity, async (ent, previousEnt) => {
  if (ent === previousEnt) {
    return;
  }
});

watch(() => service.selectedTeilnahmeId, (selected, previouslySelected) => {
  loadCardDetailState();
  //feedback.loadFeedback();
}, { immediate: true });

watch(() => service.saving, (saving, previouslySaving) => {
  /*if (!saving && previouslySaving) {
    if (state.teilnahmedaten.some((tdaten: any) => tdaten.name === state.activeEntity)) {
      loadCardDetailState();
    }
    if (service.isReviewer) {
      feedback.loadFeedback();
    }
  }*/
});

onMounted(async () => {
  loadCardDetailState();

  await Feedback.Load();
});
</script>
